// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<p class="sold-out-badge">' + bcSfFilterConfig.label.sold_out + '</p>',
    'saleLabelHtml': '<div class="sale-badge">' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div class="indiv-product-vendor-text"><a href="{{itemVendorUrl}}">{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="grid__item ' + bcSfFilterConfig.custom.grid_item_width + ' indiv-product-wrapper wow fadeIn collection-image-anim {{itemCycleClass}}">' +
                                '<div class="indiv-product">' +
                                    '{{itemImage}}' +
                                    '<div class="hp-title">' +
                                        '{{itemVendor}}' +
                                        '<a href="{{itemUrl}}">' +
                                            '<div class="indiv-product-title-text">{{itemTitle}}</div>' +
                                            '<span class="money-styling">{{itemPrice}}</span>' +
                                        '</a>' +
                                    '</div>' +
                                '</div>' +
                                '{{itemLabels}}' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination-arrow pagination-arrow--previous grid__item col-sm-4 col-md-4 col-xs-4"><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><i class="fa fa-chevron-left"></i> <span class="icon__fallback-text">Previous</span></a></li>',
    'previousDisabledHtml': '<li class="pagination-arrow pagination-arrow--previous grid__item col-sm-4 col-md-4 col-xs-4"><div class="btn btn--secondary btn--narrow btn--disabled"><i class="fa fa-chevron-left"></i> <span class="icon__fallback-text">Previous</span></div></li>',
    'nextActiveHtml': '<li class="pagination-arrow pagination-arrow--next grid__item col-sm-4 col-md-4 col-xs-4"><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><span class="icon__fallback-text">Next</span> <i class="fa fa-chevron-right"></i></a></li>',
    'nextDisabledHtml': '<li class="pagination-arrow pagination-arrow--next grid__item col-sm-4 col-md-4 col-xs-4"><div class="btn btn--secondary btn--narrow btn--disabled"><span class="icon__fallback-text">Next</span> <i class="fa fa-chevron-right"></i></div></li>',
    'paginateHtml': '<ul>{{previous}}<li class="pagination-text grid__item col-sm-4 col-md-4 col-xs-4"><div class="hidden-xs">{{pageItems}}</div></li>{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="sort-by">' + bcSfFilterConfig.label.sorting + '</label><select id="sort-by">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add cycle class
    var itemCycleClass = '';
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 2:
            if (index == 1 || (index > 2 && index % 2 == 1)) itemCycleClass = ' alpha mobile-clear tablet-clear';
            else itemCycleClass = ' omega';
            break;
        case 3:
            if (index == 1 || (index > 6 && index % 6 == 1)) itemCycleClass = ' alpha mobile-clear';
            else if (index == 2 || (index > 6 && index % 6 == 2)) itemCycleClass = '';
            else if (index == 3 || (index > 6 && index % 6 == 3)) itemCycleClass = ' mobile-clear omega';
            else if (index == 4 || (index > 6 && index % 6 == 4)) itemCycleClass = ' alpha';
            else if (index == 5 || (index > 6 && index % 6 == 5)) itemCycleClass = ' mobile-clear';
            else itemCycleClass = ' omega';
            break;
        case 4:
            if (index == 1 || (index > 4 && index % 4 == 1)) itemCycleClass = ' alpha mobile-clear tablet-clear';
            else if (index == 2 || (index > 4 && index % 4 == 2)) itemCycleClass = '';
            else if (index == 3 || (index > 4 && index % 4 == 3)) itemCycleClass = ' mobile-clear tablet-clear';
            else itemCycleClass = ' omega';
            break;
    }
    itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '760x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Image / Flip Image
    var itemImageHtml = ''
    var itemImageThumbUrl = images.length > 0 ? this.getFeaturedImage(images, '150x') : bcSfFilterConfig.general.no_image_url;
    var itemResponsiveUrl = this.optimizeImage(images[0]['src'], '1000x1000').replace('_1000x1000.', '_{width}x.');
    switch(bcSfFilterConfig.custom.hover_effect) {
        case 'none':
            itemImageHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}">';
            itemImageHtml += '<img class="lazyload product-image"' +
                                ' src="' + itemImageThumbUrl + '"' +
                                ' data-src="' + itemResponsiveUrl + '"' +
                                ' data-sizes="auto"' +
                                ' data-aspectratio="' + images[0]['width'] / images[0]['height'] + '"' +
                                ' alt="{{itemTitle}}" data-id="1" />';
            itemImageHtml += '</a>';
            break;
        case 'second-image':
            if (images.length > 1) {
                itemImageHtml += '<div class="reveal">';
                itemImageHtml += '<a class="grid__image fix" href="{{itemUrl}}" title="{{itemTitle}}">';
                itemImageHtml += '<img class="lazyload product-image"' +
                                ' src="' + this.getFeaturedImage(images, '150x') + '"' +
                                ' data-src="' + itemResponsiveUrl + '"' +
                                ' data-sizes="auto"' +
                                ' data-aspectratio="' + images[0]['width'] / images[0]['height'] + '"' +
                                ' alt="{{itemTitle}}" data-id="1" />';
                itemImageHtml += '<div class="hidden">';
                itemImageHtml += '<img class="lazyload product-image"' +
                                ' src="' + this.optimizeImage(images[1]['src'], '150x') + '"' +
                                ' data-src="' + itemResponsiveUrl + '"' +
                                ' data-sizes="auto"' +
                                ' data-aspectratio="' + images[0]['width'] / images[0]['height'] + '"' +
                                ' alt="{{itemTitle}}" data-id="1" />';
                itemImageHtml += '</div>';
                itemImageHtml += '</a></div>';
            } else {
                itemImageHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}">';
                itemImageHtml += '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
                itemImageHtml += '</a>';
            }
            break;
        case 'zoom':
            itemImageHtml += '<div class="collection-image--zoom-effect"><div class="zoom-effect--inner">';
            itemImageHtml += '<a class="grid__image fix" href="{{itemUrl}}" title="{{itemTitle}}">';
            itemImageHtml += '<div class="extra-for-image">';
            itemImageHtml += '<img class="lazyload product-image"' +
                                ' src="' + itemImageThumbUrl + '"' +
                                ' data-src="' + itemResponsiveUrl + '"' +
                                ' data-sizes="auto"' +
                                ' data-aspectratio="' + images[0]['width'] / images[0]['height'] + '"' +
                                ' alt="{{itemTitle}}" data-id="1" />';
            for(var i = 0; i < data.options_with_values.length; i++) {
              if (data.options_with_values[i]['name'].toLowerCase() == 'color') {
                if (data.options_with_values[i]['values'].length > 1) {
                  //itemImageHtml += '<p class="product-more-options">' + bcSfFilterConfig.label.more_options_available + '</p>';
                }
              }
            }
            itemImageHtml += '</div></a>';
            itemImageHtml += '</div></div>';
            break;
    }
    itemHtml = itemHtml.replace(/{{itemImage}}/g, itemImageHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendor ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor).replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor)) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<h5 class="custom-font compare-at-price">';
        itemPriceHtml += '<span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span>';
        itemPriceHtml += '</h5>';
    }
    if (!soldOut) {
        if (priceVaries) {
            itemPriceHtml += '<small>' + bcSfFilterConfig.label.from_price + '</small> <span class="money">' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
    } else {
        itemPriceHtml += bcSfFilterTemplate.soldOutLabelHtml;
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add onSale Label
    var itemLabelsHtml = '';
    if (!soldOut) {
      if (onSale) {
        itemLabelsHtml += '<div class="sale-badge">' + bcSfFilterConfig.label.sale + '</div>';
      }
    } else {
      itemLabelsHtml += '<div class="sold-out-badge">' + bcSfFilterConfig.label.sold_out + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    $(document).ready(function() {
      jQ('#bc-sf-filter-top-sorting select').material_select();
    });

    var _this = this;
    jQ('.sod_option').click(function(e) {
        onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('value'));
    })
};


    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e);if(i!=this.selector.filterTree&&i!=this.selector.filterTreeHorizontal&&jQ(i).html(""),void 0===i)i="vertical"==t?this.selector.filterTree:this.selector.filterTreeHorizontal;void 0!==r&&"before"==r?jQ(i).prepend(e):jQ(i).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
